export enum ProductTypes {
  RIO = 'RIO',
  TIO = 'TIO',
}

export type ProductType = keyof typeof ProductTypes | 'UNKNOWN';

export type ProductCode = string & {
  readonly type: unique symbol; // it means ProductCode !== string, so this is something unique and we cannot change it so easy
};

export enum Tiers {
  LIVEMORE_1 = 'LIVEMORE_1',
  LIVEMORE_2 = 'LIVEMORE_2',
  LIVEMORE_3 = 'LIVEMORE_3',
  LIVEMORE_3_PLUS = 'LIVEMORE_3_PLUS',
  LIVEMORE_4 = 'LIVEMORE_4',
  LIVEMORE_4_PLUS = 'LIVEMORE_4_PLUS',
  DEBT_CONSOLIDATION_100 = 'DEBT_CONSOLIDATION_100',
  COMPLEX = 'COMPLEX',
  STANDARD = 'STANDARD',
}

export enum ProductRepaymentTypes {
  INTEREST_ONLY = 'INTEREST_ONLY',
  CAPITAL_AND_INTEREST = 'CAPITAL_AND_INTEREST',
}

export type ProductRepaymentType = keyof typeof ProductRepaymentTypes | 'UNKNOWN';
